// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Container Styling */
.consultant-management-container {
  width: 90%; /* Adjust width as needed */
  margin: 0 auto;
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 5px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

/* Table Styling */
.consultant-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
}

.consultant-table th,
.consultant-table td {
  padding: 10px;
  text-align: left;
  border: 1px solid #ccc;
}

.consultant-table th {
  background-color: #f2f2f2;
  font-weight: bold;
}

/* Input and Select Styling */
.form-control {
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 3px;
  box-sizing: border-box;
  width: 100%; /* Make input fields take full width */
}

.form-control select {
  width: 100%; /* Make select take full width */
}

/* Button Styling */
.btn {
  padding: 8px 15px;
  border: none;
  border-radius: 3px;
  cursor: pointer;
  margin-right: 5px;
}

.btn-primary {
  background-color: #007bff; /* Blue color */
  color: white;
}

.btn-secondary {
  background-color: #6c757d; /* Gray color */
  color: white;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Views/LandInfraDevelopment/DesignAndConstructionView/Forms/ConsultantAndContractor/ManageConsultants.css"],"names":[],"mappings":"AAAA,sBAAsB;AACtB;EACE,UAAU,EAAE,2BAA2B;EACvC,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA,6BAA6B;AAC7B;EACE,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,WAAW,EAAE,sCAAsC;AACrD;;AAEA;EACE,WAAW,EAAE,gCAAgC;AAC/C;;AAEA,mBAAmB;AACnB;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,yBAAyB,EAAE,eAAe;EAC1C,YAAY;AACd;;AAEA;EACE,yBAAyB,EAAE,eAAe;EAC1C,YAAY;AACd","sourcesContent":["/* Container Styling */\r\n.consultant-management-container {\r\n  width: 90%; /* Adjust width as needed */\r\n  margin: 0 auto;\r\n  padding: 20px;\r\n  border: 1px solid #ccc;\r\n  border-radius: 5px;\r\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n/* Table Styling */\r\n.consultant-table {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n  margin-top: 20px;\r\n}\r\n\r\n.consultant-table th,\r\n.consultant-table td {\r\n  padding: 10px;\r\n  text-align: left;\r\n  border: 1px solid #ccc;\r\n}\r\n\r\n.consultant-table th {\r\n  background-color: #f2f2f2;\r\n  font-weight: bold;\r\n}\r\n\r\n/* Input and Select Styling */\r\n.form-control {\r\n  padding: 8px;\r\n  border: 1px solid #ccc;\r\n  border-radius: 3px;\r\n  box-sizing: border-box;\r\n  width: 100%; /* Make input fields take full width */\r\n}\r\n\r\n.form-control select {\r\n  width: 100%; /* Make select take full width */\r\n}\r\n\r\n/* Button Styling */\r\n.btn {\r\n  padding: 8px 15px;\r\n  border: none;\r\n  border-radius: 3px;\r\n  cursor: pointer;\r\n  margin-right: 5px;\r\n}\r\n\r\n.btn-primary {\r\n  background-color: #007bff; /* Blue color */\r\n  color: white;\r\n}\r\n\r\n.btn-secondary {\r\n  background-color: #6c757d; /* Gray color */\r\n  color: white;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
